import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    padding: '0 !important',
    fontSize: '0.875rem !important',
    color: '#646464 !important',
    fontFamily: 'DOSH !important',
    fontWeight: 'normal !important',
  },
  noPadding: {
    padding: '0 !important',
  },
  tableContainer: {
    margin: '0.625rem',
    padding: 0,
    border: '0.0625rem solid #e5e5e5',
    borderRadius: '0.3125rem',
  },
  logo: {
    backgroundColor: '#fff !important',
    border: '.078125em solid #F5F5F5 !important',
    boxSizing: 'border-box !important' as 'border-box',
    height: '2.05937em !important',
    width: '2.15625em !important',
  },
  header: {
    fontSize: '1.875rem !important',
    fontWeight: 'normal !important' as 'normal',
    marginTop: '0 !important',
  },
  centeredRow: {
    textAlign: 'center',
  },
  merchantLogo: {
    float: 'right !important',
    maxWidth: '4.375rem !important',
    position: 'absolute',
    right: '1.5625rem',
    top: 0,
  },
  dateLabel: {
    display: 'block !important',
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  datePickerWrapper: {
    '& .DayPickerInput': {
      width: '100% !important',
    },
    '& .DayPickerInput input': {
      width: '100% !important',
      margin: 0,
      maxWidth: '100%',
      outline: 0,
      textAlign: 'left',
      lineHeight: '1.21428571em',
      fontFamily: 'DOSH !important',
      padding: '.67857143em 1em',
      background: '#fff',
      border: '0.0625rem solid rgba(34,36,38,.15)',
      color: 'rgba(0,0,0,.87)',
      borderRadius: '.28571429rem',
    },
  },
  label: {
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  modal: {
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  modalHeader: {
    fontFamily: 'DOSH !important',
    fontWeight: '400 !important',
    color: '#4a4a4a !important',
  },
  tableHeader: {
    backgroundColor: '#ffffff !important',
    color: '#646464 !important',
    fontSize: '0.875rem !important',
    fontWeight: '400 !important',
    fontFamily: 'DOSH !important',
    border: 'none !important;',
    borderBottom: '0.0625rem solid rgba(34,36,38,.1) !important',
  },
  clickable: {
    cursor: 'pointer',
  },
  selectableRow: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  supplementalRow: {
    border: '0 !important;',
    background: '#fafbfb',
  },
  nameCell: {
    marginBottom: '0 !important',
    fontWeight: '500',
  },
  offerCell: {
    fontSize: '0.75rem',
    color: '#6c6c6c',
  },
  statusPill: {
    margin: '0 auto',
    borderRadius: '1.5625rem',
    textAlign: 'center',
    '& span': {
      padding: '0.125rem 1.875rem',
      color: 'white',
      fontSize: '.75rem !important',
    },
  },
  pulseIcon: {
    display: 'inline !important',
    marginRight: '.875rem !important',
    cursor: 'pointer !important',
  },
  pulseMessage: {
    display: 'inline !important',
    marginLeft: '0.3125rem !important',
  },
  capitalize: {
    textTransform: 'capitalize !important',
  },
  isOfferLive: {
    backgroundColor: '#39e27a !important',
  },
  isOfferComplete: {
    backgroundColor: '#717074',
  },
  isOfferNew: {
    backgroundColor: theme.violet,
  },
  isActive: {
    background: '#e6e7e8',
  },
  button: {
    backgroundColor: '#fff !important',
    border: 'solid .0625rem #ddd !important',
    borderRadius: '1.5rem !important',
    padding: '.85625rem 4.5em .85625rem !important',
    color: '#ddd !important',
    fontSize: '.875rem',
    margin: '.25rem .625rem !important',
    opacity: 1,
    fontWeight: 'normal !important',

    '&:hover': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.9,
    },

    '&:active': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.7,
    },

    '&.active': {
      backgroundColor: '#683caf !important',
    },
  },
  buttonPrimary: {
    backgroundColor: '#683caf !important',
    color: '#fff !important',

    '&:hover': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.9,
    },

    '&:active': {
      backgroundColor: '#683caf !important',
      color: '#fff !important',
      opacity: 0.7,
    },
  },
  buttonSecondary: {
    backgroundColor: '#a9b8c2 !important',
    color: '#fff !important',

    '&:hover': {
      backgroundColor: '#a9b8c2 !important',
      color: '#fff !important',
      opacity: 0.9,
    },

    '&:active': {
      backgroundColor: '#a9b8c2 !important',
      color: '#fff !important',
      opacity: 0.7,
    },
  },
  cancelBtn: {
    float: 'right !important',
  },
  offerBtn: {
    width: '25%',
  },
  '@global .ui.table': {
    boxShadow:
      '0 0.0625rem 0 0 rgba(0,0,0,0.03), 0 0.125rem 0.375rem 0 rgba(0,0,0,0.06); !important',
  },
  '@global .selectable .DayPicker-Caption': {
    fontSize: '1.125em',
    color: '#683caf',
  },
  '@global .selectable .DayPicker-Caption > div': {
    fontWeight: 'normal',
  },
  '@global .selectable .DayPicker-Day--selected': {
    backgroundColor: '#683caf !important',
    borderRadius: '50% !important',
    color: '#fff !important',
  },
  '@global .selectable .DayPicker-Day:hover': {
    backgroundColor: 'rgb(104,60,175, .15)!important',
    borderRadius: '50% !important',
  },
  '@global .selectable .DayPicker-Day--today': {
    color: '#f4897d !important',
  },
  '@global input[type="text"]:disabled': {
    cursor: 'not-allowed !important',
  },
  '@global .ui.table thead tr:first-child>th:last-child': {
    width: '10rem !important',
  },
});

export default styles;
